import { Component } from '@opten/compiler/metadata/component';
import { addClass } from '@opten/dom/add-class';
import { removeClass } from '@opten/dom/remove-class';
import MicroModal from 'micromodal';
import { getWindowScrollTop } from '@opten/dom/get-window-scroll-top';

@Component({
	className: 'js-advent-calendar',
	observe: false
})
export class AdventCalendarComponent {
	days: NodeListOf<Element>;
	overlay: any;
	hasOpenModal = false;
	constructor(private element: HTMLElement) {
		const svgElement = this.element.querySelector('svg');
		if (svgElement != null) {
			const currentDay = parseInt(
				this.element.getAttribute('data-current-day')
			);
			const currentMonth = parseInt(
				this.element.getAttribute('data-current-month')
			);
			this.days = svgElement.querySelectorAll('#gifts > g');
			if (this.days.length > 0) {
				this.days.forEach(day => {
					const calendarDay = parseInt(day.id.replace('gift-', ''));
					const pastDay = day.querySelector(
						'#past-gift-' + calendarDay
					);
					const presentDay = day.querySelector(
						'#present-gift-' + calendarDay
					);
					const futureDay = day.querySelector(
						'#future-gift-' + calendarDay
					);
					const modal = this.element.querySelector(
						'#advent-calendar-modal-' + calendarDay
					);
					const isPastDay = currentMonth <= 6 || (currentMonth == 12 && calendarDay < currentDay);
					const isFutureDay = isPastDay == false && ((currentMonth > 6 && currentMonth != 12) || (currentMonth == 12 && calendarDay > currentDay));
					if (isFutureDay) {
						pastDay.remove();
						presentDay.remove();
					} else if (isPastDay) {						
						presentDay.remove();
						futureDay.remove();
					} else {
						pastDay.remove();
						futureDay.remove();
					}
					addClass(day,'is-initialized');
					if (modal) {
						modal.addEventListener('close', e => {
							e.preventDefault();
							e.stopPropagation();
							e.stopImmediatePropagation();
							MicroModal.close(modal.id);
						});
					}
					day.addEventListener('click', () =>
						this.openCalendarDay(day, modal)
					);
					if(this.hasOpenModal == false && modal.querySelector('.js-form-submitted') != null){
						this.openCalendarDay(day, modal)
					}
				});
			}
		}
	}
	openCalendarDay(day: Element, modal: Element) {
		this.hasOpenModal = true;
		this.days.forEach(o => removeClass(o, 'is-open'));
		addClass(day, 'is-open');
		setTimeout(() => {
			if (modal) {
				this.overlay = modal.querySelector('.js-modal-overlay');

				const scrollTopPosition = getWindowScrollTop();
				MicroModal.show(modal.id, {
					allowTouchMove: true,
					onShow: () => {
						addClass(document.body, 'modal--is-open');
						modal.querySelector('.modal__content__inner').scroll(-1,0);
					},
					onClose: () => {
						window.scrollTo(0, scrollTopPosition);

						setTimeout(
							() => {
								removeClass(document.body, 'modal--is-open');
								removeClass(day, 'is-open');
								this.hasOpenModal = false;
							},
							600
						);
					}
				});
			}
		}, 350);
	}
}
